module.exports = __webpack_public_path__ + "img/x1.eaea821d.jpg";